import React from 'react';
import classes from "./Button.module.css";

export default function Button({label, variant, className, type, onClick, disabled}) {
  return (
    <button type={type} className={`${classes.btn} ${className} ${classes[variant]} fw-600 f-14`} disabled={disabled} onClick={onClick}>{label}</button>
  )
}
